import { KoobInputSelectField, KoobPlaceholder } from '@koob/ui';
import { getNationalityLabel } from '@koob/utils';
import { useBooking } from 'hooks';

const SelectNationatilyField = ({
  label,
  name,
  placeholder,
  disabled,
  ...props
}) => {
  const { nationalities } = useBooking();

  return (
    <KoobInputSelectField
      name={name}
      label={label}
      items={nationalities}
      renderOption={value => value?.label}
      renderValue={value => value?.label ?? getNationalityLabel(value)}
      disabled={disabled}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default SelectNationatilyField;
